// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ovklrhkrsodpunvdyebr.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im92a2xyaGtyc29kcHVudmR5ZWJyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDE4NTMwMzcsImV4cCI6MjA1NzQyOTAzN30.Z71lKqivxDVsHp0_kWyhKetlwEUn8o-42JLIyv-SuZg";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);